"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialWorkspaceModesSettingsV3 = void 0;
var TrialWorkspaceModesSettingsV3;
(function (TrialWorkspaceModesSettingsV3) {
    let DefaultMode;
    (function (DefaultMode) {
        DefaultMode["NONE"] = "None";
        DefaultMode["PRO"] = "Pro";
        DefaultMode["EXPERT"] = "Expert";
    })(DefaultMode = TrialWorkspaceModesSettingsV3.DefaultMode || (TrialWorkspaceModesSettingsV3.DefaultMode = {}));
})(TrialWorkspaceModesSettingsV3 || (exports.TrialWorkspaceModesSettingsV3 = TrialWorkspaceModesSettingsV3 = {}));
